import React, { useState } from 'react';
import { motion } from 'framer-motion';
import StatsScreen from './stats/StatsScreen.jsx';
import ConfirmModal from './ConfirmModal.jsx';

const GameOverModal = ({ state, onNextGame, onPlayAgain, onReset }) => {
  const [showStats, setShowStats] = useState(false);
  const [confirmReset, setConfirmReset] = useState(false);

  const isMatchOver = state.status === 'match_over';

  const winnerTeam = (() => {
    if (state.gamesA > state.gamesB) return state.teamNameA;
    if (state.gamesB > state.gamesA) return state.teamNameB;
    if (state.scoreA > state.scoreB) return state.teamNameA;
    if (state.scoreB > state.scoreA) return state.teamNameB;
    return state.teamNameA;
  })();

  const winnerPlayers = (() => {
    if (state.gamesA > state.gamesB) return state.playerNameA;
    if (state.gamesB > state.gamesA) return state.playerNameB;
    if (state.scoreA > state.scoreB) return state.playerNameA;
    if (state.scoreB > state.scoreB) return state.playerNameB;
    return state.playerNameA;
  })();

  return (
    <>
      <div className="fixed inset-0 z-[200] flex items-center justify-center">
        <div className="absolute inset-0 bg-slate-950/85 backdrop-blur-sm" />
        <motion.div
          initial={{ opacity: 0, scale: 0.88, y: 24 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.9 }}
          transition={{ type: 'spring', damping: 22, stiffness: 280 }}
          className="relative z-10 text-center px-8 py-10 bg-white/[0.05] border border-white/10 rounded-[3rem] max-w-sm w-full mx-4 shadow-2xl"
        >
          <div className="text-5xl mb-3">{isMatchOver ? '🏆' : '🎯'}</div>
          <div className="text-[10px] font-black text-white/30 uppercase tracking-[0.5em] mb-2">{isMatchOver ? 'Match Over' : `Game ${state.game} Over`}</div>
          <h2 className="text-3xl font-black text-white mb-1">{winnerTeam}</h2>
          <p className="text-white/40 text-sm font-bold mb-4">
            {winnerPlayers} {isMatchOver ? '贏得比賽！' : '贏得本局！'}
          </p>
          <div className="flex items-center justify-center gap-3 mb-2">
            <span className="text-2xl font-black text-indigo-400">{state.gamesA}</span>
            <span className="text-white/20 text-sm font-black">局 : 局</span>
            <span className="text-2xl font-black text-rose-400">{state.gamesB}</span>
          </div>
          <div className="text-4xl font-black tabular-nums text-white/60 mb-7">
            {state.scoreA} <span className="text-white/20 mx-2">:</span> {state.scoreB}
          </div>
          <div className="flex flex-col gap-3">
            <button
              onClick={() => setShowStats(true)}
              className="w-full py-3.5 bg-indigo-500/20 text-indigo-200 font-black rounded-2xl border border-indigo-500/30 hover:bg-indigo-500/30 transition-all active:scale-95 text-sm flex items-center justify-center gap-2"
            >
              📊 查看統計
            </button>
            {isMatchOver ? (
              <button
                onClick={onPlayAgain}
                className="w-full py-4 bg-white text-slate-900 font-black rounded-2xl hover:bg-indigo-400 hover:text-white transition-all active:scale-95 text-lg"
              >
                再來一場 🏸
              </button>
            ) : (
              <button
                onClick={onNextGame}
                className="w-full py-4 bg-white text-slate-900 font-black rounded-2xl hover:bg-indigo-400 hover:text-white transition-all active:scale-95 text-lg"
              >
                下一局 →
              </button>
            )}
            <button
              onClick={() => setConfirmReset(true)}
              className="w-full py-3.5 bg-white/5 text-white/50 font-black rounded-2xl border border-white/10 hover:bg-white/10 transition-all active:scale-95"
            >
              返回主頁
            </button>
          </div>
        </motion.div>
      </div>

      <StatsScreen
        open={showStats}
        onClose={() => setShowStats(false)}
        allPointLogs={state.allPointLogs ?? [state.pointLog ?? []]}
        teamNameA={state.teamNameA}
        teamNameB={state.teamNameB}
        pts={state.pts}
        gamesA={state.gamesA}
        gamesB={state.gamesB}
        bestOf={state.bestOf}
      />

      <ConfirmModal
        open={confirmReset}
        title="確認返回主頁?"
        desc="當前比賽進度將會清除,無法復原。是否確定返回主頁重新設定?"
        confirmLabel="確認返回主頁"
        onConfirm={() => {
          setConfirmReset(false);
          onReset();
        }}
        onCancel={() => setConfirmReset(false)}
      />
    </>
  );
};

export default GameOverModal;